export default {"src":"/_next/static/media/JWN.75399a95.svg","height":18,"width":18};